// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { groups } from './../../core/services/groups.mocks';


import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State } from '@app/access-management/state';
import { Observable, of } from 'rxjs';
import { Loadable, QueueAlertAction, AlertType, GoAction } from '@app/core';
import { UserDetailsData, UserState, UserRoleState, UserGroupsState } from './user-details.interfaces';
import { selectUserDetail } from './user-details.selectors';
import { filter, map, tap } from 'rxjs/operators';
import { LoadingUserDetailsAction } from './user-details.actions';


@Injectable({providedIn: 'root'})
export class UserDetailsFacadeService {

    loadableDetails$: Observable<Loadable | undefined> = of();
    user$: Observable<UserState> = of();
    userRoles$: Observable<UserRoleState[]> = of();
    userGroups$: Observable<UserGroupsState[]> = of();

    constructor(private store: Store<State>) {}

    initialize (username: string) {

        this.store.dispatch(new LoadingUserDetailsAction(username));

        const userDetails$: Observable<UserDetailsData> =
            this.store.pipe(select(selectUserDetail(username)), filter<UserDetailsData>(data => !!data));

        this.user$ = userDetails$.pipe( map((data) =>  data.user));

        this.userRoles$ = userDetails$.pipe(
            map((data) => data.user && data.user.roles || []),
            map((roles) => this.removeDuplicates(roles))
        );

         this.userGroups$ = userDetails$.pipe(
            map((data) => data.user && data.user.groups || [])
        );
    }

    removeDuplicates(list: UserRoleState[] = []) {
        const newList = list.reduce((acc , item) => ({...acc, [item.id]: item}), []);
        return Object.values(newList);
    }

    removeRoleSucceed (removeId: string) {
        // this.store.dispatch(new RemoveGroupByIdAction(removeId));
        this.store.dispatch(new QueueAlertAction({ alertText: `Role delete succeed.`, alertType: AlertType.SUCCESS }));
    }

    removeRoleFailed () {
        this.store.dispatch(new QueueAlertAction({ alertText: `Role delete failed.`, alertType: AlertType.ERROR }));
    }

    addUserRolesSucceed (user: any) {
        this.store.dispatch(new GoAction(['/iam/users', user.username]));
        this.store.dispatch(new QueueAlertAction({ alertText: `Roles add succeed.`, alertType: AlertType.SUCCESS }));
    }

    removeGroupSucceed (username: string) {
        this.store.dispatch(new LoadingUserDetailsAction(username));
        this.store.dispatch(new QueueAlertAction({ alertText: `Role delete succeed.`, alertType: AlertType.SUCCESS }));
    }

    removeGroupFailed () {
        this.store.dispatch(new QueueAlertAction({ alertText: `Role delete failed.`, alertType: AlertType.ERROR }));
    }


}




// WEBPACK FOOTER //
// ./src/app/access-management/state/user-details/user-details.facade.ts